import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { makesQueries } from 'data/graphql'
import { compose, withState } from 'recompose'
import { selectors as ConfigSelectors } from 'data/config'

const integrationDetailsQuery = gql`
  query getApplicationDetails($clientId: ID!, $channelId: ID!) {
    getApplication(clientId: $clientId) {
      name
      isInstalled
      integration {
        id
        hasIntegrationActivitySupport
        activitySettingsForChannel(channelId: $channelId) {
          target
          enabled
        }
      }
    }
  }
`

export default function withSlackIntegrationDetails() {
  return compose(
    connect(state => {
      return {
        clientId: ConfigSelectors.getSlackAppSliteClientId(state),
      }
    }),
    withState('integrationDetails', 'setIntegrationDetails', undefined),
    withState('integrationDetailsLoaded', 'setIntegrationDetailsLoaded', false),
    makesQueries({
      query: integrationDetailsQuery,
      mapPropsToVariables: ({ clientId, channelId }) => ({
        clientId,
        channelId,
      }),
      getOnResultFromProps({
        setIntegrationDetailsLoaded,
        setIntegrationDetails,
      }) {
        return function providesIntegrationDetailsOnResult({ result }) {
          setIntegrationDetails(result.data.getApplication)
          setIntegrationDetailsLoaded(true)
        }
      },
      getOnErrorFromProps({
        setIntegrationDetailsLoaded,
        setIntegrationDetails,
      }) {
        return function providesIntegrationDetailsOnError() {
          setIntegrationDetails(null)
          setIntegrationDetailsLoaded(true)
        }
      },
    })
  )
}
